import React, { forwardRef } from 'react';
import cn from 'classnames';
import SvgIcon from '../../../../common/SvgIcon';
import BriefPackagePlan from './BriefPackagePlan';
import BriefPackageRoom from './BriefPackageRoom';

const BriefPackage = (
  { value, rooms, prices, packages, children, className, invalid, onChange, onRemove },
  ref,
) => {
  return (
    <div ref={ref} className={cn('tab', className)}>
      <div className="tab_question">Question 4 of 7</div>
      <div className="tab_tag">
        <SvgIcon icon="icon-question-step-5" />
      </div>
      <div className="tab_title">
        <div className={cn('-bold', { 'has-error -error-position-right': invalid })}>
          Which package would you like for your room(s)?
          {invalid && (
            <div className="form-error">
              you need to choose the packages for
              <br />
              your other room(s)
            </div>
          )}
        </div>
        <div className="tile-selection_bottom-description">
          (Packages available depend on room type)
        </div>
      </div>

      <div className="getting-started_tags">
        {rooms.map(room => (
          <BriefPackageRoom
            key={room.value}
            value={value}
            prices={prices}
            room={room}
            removable={rooms.length > 1}
            onChange={onChange}
            onRemove={onRemove}
          />
        ))}
      </div>

      <div className="getting-started_packages -inline">
        {packages.map(plan => (
          <BriefPackagePlan key={plan.id} plan={plan} />
        ))}
      </div>

      {children}

      <div className="tab_hint">
        Still have questions? You can&nbsp;
        <a href="/free-consultation/new">
          schedule a call
        </a>
        &nbsp;or&nbsp;
        <a href="mailto:hello@mybespokeroom.com" target="_blank" rel="noopener noreferrer">
          e-mail
        </a>
        &nbsp;us.
      </div>
    </div>
  );
};

export default forwardRef(BriefPackage);



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefPackage/BriefPackage.js